<div class="toggle-container">
  <span class="toggle-left-label" [ngClass]="{ 'toggle-checked-label': !checked }">{{
    labels.left
  }}</span>
  <mat-slide-toggle [checked]="checked" (change)="onToggleClick()" [hideIcon]="true">
  </mat-slide-toggle>
  <span class="toggle-right-label" [ngClass]="{ 'toggle-checked-label': checked }">{{
    labels.right
  }}</span>
</div>
